import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import './Auth.css';

export default function Register() {
  const [form, setForm] = useState({ name: '', email: '', password: '', confirm: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { register } = useAuth();
  const navigate = useNavigate();

  const handleChange = e => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (form.password !== form.confirm) { setError('Passwords do not match.'); return; }
    if (form.password.length < 6) { setError('Password must be at least 6 characters.'); return; }
    setLoading(true);
    try {
      await register(form.name, form.email, form.password);
      navigate('/dashboard');
    } catch (err) {
      setError(err.response?.data?.error || 'Registration failed. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const strength = !form.password ? 0 : form.password.length < 6 ? 1 : form.password.length < 10 ? 2 : 3;
  const strengthLabel = ['', 'Weak', 'Good', 'Strong'];
  const strengthColor = ['', '#ef4444', '#f59e0b', '#10b981'];

  return (
    <div className="auth-page">
      <div className="auth-bg">
        <div className="orb-1" /><div className="orb-2" />
      </div>
      <div className="auth-card fade-in">
        <div className="auth-logo">
          <span className="logo-icon">◈</span>
          <span>NOTE <span>APEX</span></span>
        </div>
        <h1>Create account</h1>
        <p className="auth-sub">Start capturing your ideas today</p>

        {error && <div className="auth-error">⚠ {error}</div>}

        <form onSubmit={handleSubmit} className="auth-form">
          <div className="form-group">
            <label>Full Name</label>
            <input className="input" type="text" name="name" placeholder="Alex Johnson" value={form.name} onChange={handleChange} required minLength={2} autoFocus />
          </div>
          <div className="form-group">
            <label>Email</label>
            <input className="input" type="email" name="email" placeholder="you@example.com" value={form.email} onChange={handleChange} required />
          </div>
          <div className="form-group">
            <label>Password</label>
            <input className="input" type="password" name="password" placeholder="Min. 6 characters" value={form.password} onChange={handleChange} required minLength={6} />
            {form.password && (
              <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginTop: 4 }}>
                <div style={{ flex: 1, height: 3, background: 'var(--border)', borderRadius: 2, overflow: 'hidden' }}>
                  <div style={{ width: `${(strength / 3) * 100}%`, height: '100%', background: strengthColor[strength], transition: 'all 0.3s', borderRadius: 2 }} />
                </div>
                <span style={{ fontSize: '0.72rem', color: strengthColor[strength], fontFamily: 'var(--font-mono)' }}>{strengthLabel[strength]}</span>
              </div>
            )}
          </div>
          <div className="form-group">
            <label>Confirm Password</label>
            <input className="input" type="password" name="confirm" placeholder="Repeat password" value={form.confirm} onChange={handleChange} required />
          </div>
          <button className="btn btn-primary w-full auth-submit" type="submit" disabled={loading}>
            {loading ? <span className="spinner" /> : 'Create Account →'}
          </button>
        </form>

        <p className="auth-footer">
          Already have an account? <Link to="/login">Sign in</Link>
        </p>
        <Link to="/" className="back-home">← Back to home</Link>
      </div>
    </div>
  );
}
